define(function(require) {
    return {
        LAYER_ID : "FIND_ROUTES",
        LAYER_TYPE : "POLYLINE",
        LOADING_MODE : "ON_DEMAND",
        USE_TYPED_ARRAY : true,
        INDEX : 18,
        DATATABLE_ID : "t_FIND_ROUTES",
        FIELDS : [
            {ID : "NAME", NAME : "Nom", DATA_TYPE: "STRING", VALUE: "{{NAME}}"},
            {ID : "TEMPS", NAME : "Temps (min)", DATA_TYPE: "STRING", VALUE: "{{TEMPS}}", DECIMAL_PLACES: 1},
            {ID : "DISTANCE", NAME : "Distance (km)", DATA_TYPE: "STRING", VALUE: "{{DISTANCE}}", DECIMAL_PLACES: 1}
        ],
        STYLES : [
            {
                ID : "s_Default",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolylineSymbolizer",
                        STROKE_COLOR : "RANDOM",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : "5"
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Itinéraires",
            UNIQUE_FEATURES_STYLES : true,
            BLEND_MODE : "MULTIPLY",
            FEATURE_NAME_DATACOLUMN : "NAME",
            DATATIP_DATACOLUMNS : ["NAME"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["NAME", "TEMPS", "DISTANCE"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["NAME", "TEMPS", "DISTANCE"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            IS_VISIBLE_IN_LAYER_CONTROL : true,
            IS_VISIBLE_IN_LEGEND : false,
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "DISTANCE",
            VISIBLE : true,
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 10,
                VISIBLE : true
            }
        }
    };
});
